import { Link } from "react-router-dom";
import { ProductIcon } from "@/components/ProductIcon";
import { getFeaturedProducts } from "@/data/catalog";

// Marquee strip of real product icons (no claims, no metrics).
export function IconStrip() {
  const items = getFeaturedProducts(12);
  const loop = [...items, ...items];
  return (
    <section
      data-testid="icon-strip"
      className="overflow-hidden border-b border-nm-border bg-nm-bg2 py-5"
      aria-label="Produk yang tersedia"
    >
      <div className="flex w-max marquee-track gap-4">
        {loop.map((product, i) => (
          <Link
            key={`${product.slug}-${i}`}
            to={`/produk/${product.slug}`}
            aria-label={product.name}
            className="flex shrink-0 items-center gap-2 rounded-full border border-nm-border bg-nm-surface px-3 py-1.5 transition-colors hover:border-nm-red/40"
          >
            <ProductIcon product={product} className="h-6 w-6" rounded="rounded-md" />
            <span className="whitespace-nowrap text-xs font-semibold text-nm-muted">
              {product.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
